module.exports = __webpack_public_path__ + "static/media/da_logo.b5f6caa4.jpg";